<template>
	<div style="height: 100%; width: 100%;" class="content-pad-vert">
		<div class="nav-container">
			<div class="parallelogramlogo">
				<div class="unskew">
					<div class="d-inline-block">
						<img style="cursor: pointer" @click="saveAndExit" src="/static/images/navbar/logo-color.svg" height="35" alt="WRKPRTY" />
					</div>
				</div>
			</div>
			<div class="d-inline-block pa-3" style="float: right">
				<h4 class="hidden-xs-only">
					<v-btn @click="help" flat small class="pa-1" style="min-width: auto">Help</v-btn>|<v-btn @click="saveAndExit" flat small class="pa-1">Save &amp; Exit</v-btn>
				</h4>
				<v-menu bottom offset-y>
					<v-btn slot="activator" icon>
						<v-icon>
							menu	
						</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile v-for="(item, i) in menuItems" :key="i" @click="item.scr">
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</div>
		<v-container fluid class="ma-0 pa-0">
			<v-layout row wrap>
				<v-flex sm4 md3 hidden-xs-only class="add-event-progress-tab pa-4 pt-5">
					<div class="add-event-progress-border pt-1 pb-5">
						<div v-for="(step, index) in steps" class="mb-3 pl-4" :key="index">
							<div v-if="index === 0" @click="routeToLink(step.link)" :class="isSelected(step.link)">
								<p style="font-size: 1.5em" class="mb-3">{{ step.title }}</p>
							</div>
							<div v-else-if="index !== steps.length-1 && index !== steps.length-2" @click="routeToLink(step.link)" :class="isSelected(step.link)">
								<div style="display: inline-block; width: 35px;">
									<v-icon style="color: #25e684; font-size: 1.28em;" v-if="stepIsValid(step.link)">fal fa-check</v-icon>
									<v-icon class="add-event-step-icon-invalid" style="font-size: 1.28em;" v-else-if="stepIsInvalid(step.link)">fal fa-exclamation-circle</v-icon>
									<v-icon style="font-size: 1.28em;" v-else>fal fa-circle</v-icon>
								</div>
								<div style="display: inline-block">
									{{ step.title }}
								</div>
							</div>
							<div v-else-if="index === steps.length-2" @click="routeToLink(step.link)" :class="[isSelected(step.link), 'mt-4']">
								<div style="display: inline-block; width: 35px;">
									<v-icon style="color: #25e684; font-size: 1.28em;"  v-if="stepIsValid(step.link)">fal fa-check</v-icon>
									<v-icon class="add-event-step-icon-invalid" style="font-size: 1.28em;" v-else-if="stepIsInvalid(step.link)">fal fa-exclamation-circle</v-icon>
									<v-icon style="font-size: 1.28em" v-else-if="!getHost.can_add_extras">fal fa-lock</v-icon>
									<v-icon style="font-size: 1.28em" v-else>fal fa-circle</v-icon>
								</div>
								<div style="display: inline-block">
									{{ step.title }}
								</div>
							</div>
							<div v-else @click="routeToLink(step.link)" :class="[isSelected(step.link), 'mt-4']">
								<div style="display: inline-block; width: 35px;">
									<v-icon style="color: #25e684; font-size: 1.28em;" v-if="getAddEventProp('validSteps').length >= steps.length - 1">fal fa-check</v-icon>
									<v-icon style="font-size: 1.28em" v-else-if="!visitedSubmit && !unlockSubmit">fal fa-lock</v-icon>
									<v-icon style="font-size: 1.28em" v-else>fal fa-circle</v-icon>
								</div>
								<div style="display: inline-block">
									{{ step.title }}
								</div>
							</div>
						</div>
					</div>
				</v-flex>
				<v-flex xs12 sm8 md9 class="pl-4 pt-5 pr-4 pb-5" style="min-height: 100vh;">
					<p class="add-event-step-error" v-if="locationError">Please select a location before continuing</p>
					<p class="add-event-step-error" v-if="typeError">Please select an event type before continuing</p>
					<router-view></router-view>
					<div class="hidden-xs-only text-xs-center" style="width: 50%">
						<v-btn
							v-if="getStep.link === steps[0].link"
							@click="goToNextStep"
							class="btn-min-height btn-blue btn-large elevation-2"
							style="width: 200px;"
						>
							Continue
						</v-btn>
						<v-btn
							v-else-if="(!getHost.can_add_extras) && (getStep.link === steps[steps.length-2].link)"
							@click="goToNextStep" 
							class="btn-min-height btn-blue btn-large elevation-2"
							:disabled="disableButton"
							style="width: 250px;"
						>
							Skip
						</v-btn>
						<v-btn
							v-else-if="getStep.link !== steps[steps.length-1].link"
							@click="goToNextStep" 
							class="btn-min-height btn-blue btn-large elevation-2"
							:disabled="disableButton"
							style="width: 250px;"
						>
							Save and Continue
						</v-btn>
						<v-btn
							v-else
							@click="submit"
							class="btn-min-height btn-blue btn-large elevation-2"
							:disabled="!getAddEventReadyToSubmit || !getAddEventProp('confirmLocationUse')"
							style="width: 250px;"
							:loading="submitting"
						>
							Submit
						</v-btn>
					</div>
					<!-- <v-layout class="hidden-xs-only">
						<v-flex sm6 class="text-xs-center">
						</v-flex>
					</v-layout> -->
				</v-flex>
			</v-layout>
			<div class="hidden-sm-and-up" style="height: 80px;">
			</div>
			<v-card v-if="!hostProcessModal" class="add-event-mobile-bottom-nav pa-0 hidden-sm-and-up">
				<v-card-actions class="pa-0">
					<v-btn large flat v-if="((getStep.link !== steps[0].link) && !visitedSubmit)" class="ma-0 add-event-mobile-bottom-nav-back" @click="goToPreviousStep()" :disabled="getStep === steps[0]">Back</v-btn><v-btn v-if="getStep.link === steps[0].link" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="goToNextStep">Begin</v-btn><v-btn large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" v-else-if="(visitedSubmit === true && getStep.link !== steps[steps.length-1].link)" @click="routeTo('/host/add/event/submit/')">Return to Review</v-btn><v-btn v-else-if="(!getHost.can_add_extras) && (getStep.link === steps[steps.length-2].link)" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-next" @click="goToNextStep()">Skip</v-btn><v-btn v-else-if="getStep.link !== steps[steps.length-1].link" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-next" @click="goToNextStep()">Next</v-btn><v-btn v-else-if="!userIsHost" large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="submit('/host/dashboard/?host-application=submitted')" :disabled="!getAddEventReadyToSubmit || !getAddEventProp('confirmLocationUse')"><span v-if="getAddEventReadyToSubmit && getAddEventProp('confirmLocationUse')" :loading="submitting">Submit</span><span v-else-if="!getAddEventReadyToSubmit" class="add-event-step-invalid">Fix Errors</span><span v-else class="add-event-step-invalid">Confirm Location Use Terms</span></v-btn><v-btn v-else large flat class="btn-blue ma-0 add-event-mobile-bottom-nav-begin" @click="submit('/')" :disabled="!getAddEventReadyToSubmit || !getAddEventProp('confirmLocationUse')"><span v-if="getAddEventReadyToSubmit && getAddEventProp('confirmLocationUse')" :loading="submitting">Submit</span><span v-else-if="!getAddEventReadyToSubmit" class="add-event-step-invalid">Fix Errors</span><span v-else class="add-event-step-invalid">Confirm Location Use Terms</span></v-btn>
				</v-card-actions>
			</v-card>
			<v-btn small fab bottom right fixed class="btn-yellow add-event-mobile-info-button hidden-md-and-up" v-if="!hostProcessModal" @click="hostProcessModal=true"><img src="/static/images/icon/light-bulb-gray.svg" width="30" /></v-btn>
			<!-- <v-layout class="add-event-mobile-step-count hidden-sm-and-up" justify-center style="width: 100vw;">
				<v-chip color="grey" text-color="black">
					Step {{curentStepNum}}/{{steps.length}}
				</v-chip>
			</v-layout> -->
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { postEvent, fetchEventTags } from '~/store/api/event_location_api'
import { parseTimeString, deepCopy } from '~/store/util/util'
import { parse, format } from 'date-fns'
import axios from 'axios'
import moment from 'moment'
export default {
	data() {
		return {
			submitting: false,
			submitAttempt: false,
			foo: 'asdf',
			menuItems: [
				{
					title: 'Help',
					scr: this.help
				},
				{
					title: 'Save & Exit',
					scr: this.saveAndExit
				}
			],
			steps: [
				{ title: 'Create Event', link: '/host/add/event' },
				{ title: 'Location', link: '/host/add/event/location' },
				{ title: 'Event Type', link: '/host/add/event/type' },
				{ title: 'Date & Time', link: '/host/add/event/schedule' },
				{ title: 'Description', link: '/host/add/event/description' },
				// { title: 'Frequency', link: '/host/add/event/frequency' },
				{ title: 'Capacity & Price', link: '/host/add/event/seating' },
				{ title: 'Provisions', link: '/host/add/event/amenities' },
				{ title: 'Open to...', link: '/host/add/event/restrictions' },
				// { title: 'What to Bring', link: '/host/add/event/what-to-bring' },
				{ title: 'Notes & Instructions', link: '/host/add/event/notes' },
				// { title: 'Sponsors', link: '/host/add/event/sponsors' },
				{ title: 'Photos', link: '/host/add/event/photos' },
				{ title: 'Extras', link: '/host/add/event/extras' },
				// { title: 'Schedule & Format', link: '/host/add/event/format' },
				{ title: 'Review & Submit', link: '/host/add/event/submit' }
			],
			currentStepPath: window.location.pathname,
			locError: false,
			typError: false
		}
	},
	beforeRouteLeave(to, from, next) {
		let currentPage = this.$router.currentRoute.path
		let startPage = this.steps[0].link
		let locationPage = this.steps[1].link
		let submitPage = this.steps[this.steps.length - 1].link
		if (
			(locationPage === currentPage || locationPage + '/' === currentPage) &&
			this.getAddEventProp('partialEventPk') === null
		) {
			this.startPartialEvent()
		} else if (
			startPage !== currentPage &&
			startPage + '/' !== currentPage &&
			submitPage !== currentPage &&
			submitPage + '/' !== currentPage
		) {
			this.updatePartialEvent()
		}
		next()
	},
	created() {
		this.fetchAllLocations()
	},
	mounted() {},
	methods: {
		...mapActions([
			'setHostHelpOpen',
			'fetchAllLocations',
			'postEvent',
			'setEventTags',
			'setAddEventEventTagValues',
			'addEventResetState',
			'setAddEventProp',
			'setSnackbarOpen',
			'setSnackbarText',
			'setModalOpen',
			'setModalProp',
			'setGenericModalText',
			'setGenericModalTitle',
			'addEvent',
			'startPartialEvent',
			'updatePartialEvent',
			'deletePartialEvent'
		]),
		help() {
			this.setModalOpen({ prop: 'hostProcessModal', value: true })
			this.setModalProp({
				prop: 'hostProcessModalPage',
				value: 'host_add_event_intro'
			})
		},
		saveAndExit() {
			this.$router.push({ name: 'host_dashboard' })
		},
		begin() {
			this.routeTo(this.steps[0].link)
		},
		submit() {
			// Recurring value
			let recurring
			if (this.getAddEventProp('frequency') === 'recurring') {
				recurring = this.getAddEventProp('recurringFrequency')
			} else {
				recurring = 'one'
			}

			// Provisions
			let provisions = JSON.stringify({
				provisions: this.getAddEventProp('locationInfo'),
				infoInputs: this.getAddEventProp('locationInfoInputs'),
				amenities: this.getAddEventProp('provisions'),
				amenitiesInputs: this.getAddEventProp('provisionsInputs')
			})

			// Images
			let primaryImage = this.getAddEventProp('primaryImage')
			if (primaryImage === null) {
				if (this.getAddEventProp('images').length > 0) {
					primaryImage = this.getAddEventProp('images')[0]
				}
			}
			let additionalImages = this.getAddEventProp('images').slice(0)

			if (additionalImages !== []) {
				let primaryIndex = additionalImages.indexOf(primaryImage)
				additionalImages.splice(primaryIndex, 1)
			}

			let event_data = {
				title: this.getAddEventProp('title') + ' @ ' + this.locationName,
				subtitle: this.getAddEventProp('subtitle'),
				description: this.getAddEventProp('description'),
				category: this.getAddEventProp('wrkprtyType'),
				max_attendees: this.getAddEventProp('seats'),
				primary_image: primaryImage,
				additional_images: additionalImages,
				recurring: recurring,
				location_rules: this.getAddEventProp('rules'),
				notes: this.getAddEventProp('notes'),
				provisions: provisions,
				date: this.getAddEventProp('date'),
				time_start: format(parse(this.getAddEventProp('startTime')), 'HH:mm:ss'),
				time_end: format(parse(this.getAddEventProp('endTime')), 'HH:mm:ss'),
				location: this.locationId,
				price: this.getAddEventProp('price'),
				event_format: JSON.stringify(this.getAddEventProp('format')),
				restrictions: JSON.stringify({
					provisions: deepCopy(this.getAddEventProp('restrictionInfo')),
					inputs: this.getAddEventProp('restrictionInfoInputs'),
					approval: this.getAddEventProp('approvalOption')
				})
			}

			// Addon
			if (this.getAddonValid) {
				console.log('adding addon')
				let addon = new Array({
					start_time: this.parseAddonTimeString(this.getAddEventProp('addonStartTime')),
					end_time: this.parseAddonTimeString(this.getAddEventProp('addonEndTime')),
					title: this.getAddEventProp('addonTitle'),
					description: this.getAddEventProp('addonDescription'),
					price: this.getAddEventProp('addonPrice'),
					time_slot: this.getAddEventProp('addonTimeSlot'),
					approved: true
				})
				event_data['addons'] = JSON.stringify(addon)
			}

			this.submitting = true
			axios({
				method: 'post',
				url: '/api/v1/event/',
				data: event_data
			})
				.then(response => {
					this.deletePartialEvent(this.getAddEventProp('partialEventPk'))
					this.addEvent(response.data)
					this.$router.push('/host/dashboard/')
					this.$router.push('/events/' + response.data.slug)
					this.addEventResetState()
				})
				.catch(error => {
					this.submitting = false
					console.log(error)
					this.setModalOpen({ prop: 'genericModal', value: true })
					this.setGenericModalTitle('Error')
					let errors = ['ERROR: Event Error']
					if (typeof error.response.data !== 'string') {
						for (var prop in error.response.data) {
							if (error.response.data.hasOwnProperty(prop)) {
								errors.push(prop + ': ' + error.response.data[prop])
							}
						}
					} else {
						errors.push(error.response.data)
					}
					this.setGenericModalText(errors)
				})

			this.submitAttempt = true
		},
		parseAddonTimeString(timeString) {
			return moment(timeString).format('h:mm a')
		},
		goToNextStep() {
			let currentPage = this.$router.currentRoute.path
			let locationPage = this.steps[1].link
			let typePage = this.steps[2].link
			if (locationPage === currentPage || locationPage + '/' === currentPage) {
				if (this.getAddEventProp('location') === null) {
					console.log('location not selected')
					this.locationError = true
					return
				}
			}
			if (typePage === currentPage || typePage + '/' === currentPage) {
				if (this.getAddEventProp('wrkprtyType') === null) {
					this.typeError = true
					return
				}
			}
			for (var i = 0; i < this.steps.length; i++) {
				let linkPage = this.steps[i].link
				if (linkPage === currentPage || linkPage + '/' === currentPage) {
					this.routeTo(this.steps[i + 1].link)
					return
				}
			}
			this.routeTo(this.steps[0].link)
		},
		goToPreviousStep() {
			let currentPage = this.$router.currentRoute.path
			for (var i = 0; i < this.steps.length; i++) {
				let linkPage = this.steps[i].link
				if (linkPage === currentPage || linkPage + '/' === currentPage) {
					if (i - 1 > 0) {
						this.routeTo(this.steps[i - 1].link)
						return
					}
				}
			}
			this.routeTo(this.steps[0].link)
		},
		routeTo(url) {
			let currentPage = this.$router.currentRoute.path
			let startPage = this.steps[0].link
			let locationPage = this.steps[1].link
			if (
				(locationPage === currentPage || locationPage + '/' === currentPage) &&
				this.getAddEventProp('partialEventPk') === null
			) {
				this.startPartialEvent()
			} else if (startPage !== currentPage && startPage + '/' !== currentPage) {
				this.updatePartialEvent()
			}
			this.$router.push(url)
		},
		routeToLink(url) {
			let currentPage = this.$router.currentRoute.path
			let startPage = this.steps[0].link
			let locationPage = this.steps[1].link
			let typePage = this.steps[2].link
			if (startPage === currentPage || startPage + '/' === currentPage) {
				if (
					url === locationPage ||
					(url === typePage && this.getAddEventProp('location') !== null)
				) {
				} else if (this.getAddEventProp('location') === null) {
					this.locationError = true
					return
				} else if (this.getAddEventProp('wrkprtyType') === null) {
					this.typeError = true
					return
				}
			}
			if (locationPage === currentPage || locationPage + '/' === currentPage) {
				if (url === startPage) {
				} else if (this.getAddEventProp('location') === null) {
					this.locationError = true
					return
				} else if (this.getAddEventProp('wrkprtyType') === null) {
					this.typeError = true
					this.routeTo('/host/add/event/type')
					return
				}
			}
			if (typePage === currentPage || typePage + '/' === currentPage) {
				if (url === locationPage || url === startPage) {
				} else if (this.getAddEventProp('wrkprtyType') === null) {
					console.log('type not selected')
					this.typeError = true
					return
				}
			}
			if (url === '/host/add/event/submit') {
				if (
					this.getAddEventProp('validSteps').length >= this.steps.length - 1 ||
					this.visitedSubmit ||
					this.unlockSubmit
				) {
					this.routeTo(url)
				}
			} else {
				this.routeTo(url)
			}
		},
		isSelected(link) {
			let ar = link.split('/')
			let linkPage = ar[ar.length - 1]

			ar = this.$router.currentRoute.path.split('/')
			while (ar[ar.length - 1] === '' && ar.length > 0) {
				ar.pop()
			}
			let currentPage = ar[ar.length - 1]

			if (linkPage === currentPage) {
				return 'add-event-step-link-selected'
			} else {
				return 'add-event-step-link'
			}
		},
		stepIsValid(stepLink) {
			return (
				this.getAddEventProp('validSteps').includes(stepLink) ||
				this.getAddEventProp('validSteps').includes(stepLink + '/')
			)
		},
		stepIsInvalid(stepLink) {
			return (
				this.getAddEventProp('invalidSteps').includes(stepLink) ||
				this.getAddEventProp('invalidSteps').includes(stepLink + '/')
			)
		}
	},
	watch: {
		$route(to, from) {
			this.submitting = false
			let val = to.path
			this.currentStepPath = val
			// console.log(to)
		}
	},
	computed: {
		...mapGetters([
			'getEventTags',
			'getModalProp',
			'getHost',
			'getAddEventProp',
			'userIsHost',
			'getMyLocations',
			'getAddEventReadyToSubmit',
			'getAddonValid',
			'getHostProp'
		]),
		getStep() {
			// let ar = this.$router.currentRoute.path.split('/')
			// while (ar[ar.length - 1] === '' && ar.length > 0) {
			// 	ar.pop()
			// }
			// let currentPage = ar[ar.length - 1]

			for (var i = 0; i < this.steps.length; i++) {
				// ar = this.steps[i].link.split('/')
				// let linkPage = ar[ar.length - 1]
				if (
					this.steps[i].link === this.currentStepPath ||
					this.steps[i].link + '/' === this.currentStepPath
				) {
					return this.steps[i]
				}
			}
			return this.steps[0]
		},
		getCurrentPage() {
			return this.$router.currentRoute.path.slice(0, -1)
			// return window.location.pathname.slice(0, -1)
		},
		curentStepNum() {
			return this.steps.indexOf(this.getStep) + 1
		},
		hostProcessModal: {
			get() {
				return this.getModalProp('hostProcessModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'hostProcessModal', value: val })
				this.setModalProp({
					prop: 'hostProcessModalPage',
					value: this.$router.currentRoute.name
				})
			}
		},
		visitedSubmit() {
			return this.getAddEventProp('visitedSubmit')
		},
		locationError: {
			get() {
				if (this.locError) {
					return this.locError
				} else {
					return false
				}
			},
			set(val) {
				this.locError = val
			}
		},
		typeError: {
			get() {
				if (this.typError) {
					return this.typError
				} else {
					return false
				}
			},
			set(val) {
				this.typError = val
			}
		},
		disableButton() {
			let currentPage = this.$router.currentRoute.path
			let startPage = this.steps[0].link
			let locationPage = this.steps[1].link
			let typePage = this.steps[2].link

			if (
				(currentPage === locationPage || locationPage + '/' === currentPage) &&
				this.getAddEventProp('location') === null
			) {
				return true
			} else if (
				(currentPage === typePage || typePage + '/' === currentPage) &&
				this.getAddEventProp('wrkprtyType') === null
			) {
				return true
			}
		},
		locationName() {
			return this.getAddEventProp('location').name
		},
		locationId() {
			return this.getAddEventProp('location').pk
		},
		unlockSubmit() {
			return (
				this.getAddEventProp('validSteps').length >= this.steps.length - 2 &&
				!this.getAddEventProp('validSteps').includes(
					this.steps[this.steps.length - 2].link
				)
			)
		}
	}
}
</script>

<style lang="scss">
.submit-btn {
	background-color: #74cbf1 !important;
}
.mobile-submit-btn {
	background: white;
	z-index: 1;
	padding: 0px;
	position: fixed;
	width: 100%;
	bottom: 0px;
	left: 0;
	right: 0;
	.btn {
		margin: 0;
		padding: 0px;
		width: 100%;
		opacity: 1;
	}
}
</style>
